<template>
  <v-app v-if="shouldRenderApp">
    <main class="main-container">
      <Header v-if="!this.$route.meta.isHideHeader" />
      <div v-if="!this.$route.meta.isHideHeader" class="main">
        <div class="main__content">
          <div :class="{'wrap_content': this.$route.meta.showBetslip}">
            <router-view></router-view>
            <Betslip
              v-if=" this.$route.meta.showBetslip || showBetslip"
            />
          </div>
        </div>
        <p class="main__note">
          {{ getTranslatedText("last login:") }}
          <span>{{ $helpers.formatDateTime(dateTimeLogin) }}</span>
        </p>
      </div>
      <router-view v-else></router-view>
      <div class="view_betslip" @click="HandlShowBetslip" v-if="!this.$route.meta.isHideHeader && $store.state.isScreenMobile">
        <span>{{ getTranslatedText("view betslip") }}</span><span>{{ $store.state.dataBetslip.length }}</span>
      </div>
    </main>
    <Notifications />
    <DialogComponent />
  </v-app>
  <div v-else class="access-denied" v-show="accessDeniedVisible">
    {{ getTranslatedText("Access denied. Please use the app for access.") }}
  </div>
</template>
<script>
import Notifications from "@/components/common/notications";
import DialogComponent from "@/components/common/dialog";
import Header from "@/components/header";
import Betslip from "@/components/common/betslip";
import languageMixins from "@/mixins/language/language-mixins";
import errorDeviceMinxins from "@/mixins/errorDevice/errorDevice-mixins";
import EventBus from './utils/EventBus'
import GamesService from "@/services/games.service";
import {getUserInfo} from '@/services/axios'
import {setSettingDevice, isStrEmpty, compareVersions } from './utils/utils'
import { version } from '../package.json'
import AuthService from "@/services/auth.service"
import { getAccessToken } from '@/services/axios'
const TIME_LOGOUT = process.env.VUE_APP_TIME_LOGOUT || 30;

export default {
  mixins: [languageMixins, errorDeviceMinxins],
  components: {
    Notifications,
    DialogComponent,
    Header,
    Betslip,
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      showBetslip:false,
      timeout: null,
      shouldRenderApp: false,
      accessDeniedVisible: false,
    };
  },
  watch: {
    screenWidth(value) {
      if (value <= 768) {
        this.$store.state.isScreenMobile = true;
      } else {
        this.$store.state.isScreenMobile = false;
      }
    },
  },
  beforeMount(){
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    clearTimeout(this.timeout);
  },
  mounted() {
    document.addEventListener('message', this.handleMessage);
    if(this.$route.path !== '/login') {
      this.$store.dispatch('fetchDataConfig').then((res) => {
        this.checkErrorDevice(this.$router, res)
      }).catch((err)=>{
        this.checkErrorDevice(this.$router, err)
      })
    }

    const allowedWithoutDeviceInfo = process.env.VUE_APP_ALLOWED_WORKING_WITHOUT_DEVICE_INFO === 'true';
    if (allowedWithoutDeviceInfo) {
      this.shouldRenderApp = true;
    }

    // Delay the visibility of access denied message
    setTimeout(() => {
      if (!this.shouldRenderApp) {
        this.accessDeniedVisible = true;
      }
    }, 3000);

    this.checkTimeOnReturn();
    this.handleResetTime();
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
    ['mousemove', 'keydown', 'click', 'keypress'].forEach((event) => {
      document.addEventListener(event, this.handleResetTime)
    })
  },
  beforeDestroy() {
    document.removeEventListener('message', this.handleMessage);

    ['mousemove', 'keydown', 'click', 'keypress'].forEach((event) => {
      document.removeEventListener(event, this.handleResetTime)
    })
  },
  created() {
    this.fetchData();

    this.$store.state.versionApp = version
    if (this.screenWidth <= 768) {
      this.$store.state.isScreenMobile = true;
    } else {
      this.$store.state.isScreenMobile = false;
    }
    this.handleResize()
    window.addEventListener("resize", this.handleResize);
  },
  computed:{
    dateTimeLogin(){
      const userInfo = this.$store.state.userInfo;
      const userInfoLocal = getUserInfo() ? JSON.parse(getUserInfo()) : null;
      return userInfo ? userInfo?.last_logged : userInfoLocal?.last_logged;
    }
  },
  methods: {
    async fetchData() {
      this.$store.state.dataBetslip = !isStrEmpty(localStorage.getItem('betslip')) ? JSON.parse(localStorage.getItem('betslip')) : []
      this.$store.state.dataCheckout = !isStrEmpty(localStorage.getItem('checkout')) ? JSON.parse(localStorage.getItem('checkout')) : []
      if (this.$route.path !== '/login') {
        await GamesService.getListGame();
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth <= 768) {
        this.showBetslip = true;
      }
      else{
        this.showBetslip = false;
      }
    },
    handleMessage(event) {
      const resp = JSON.parse(event.data)
      if (resp.command === 'go-back') {
        if (this.$route.name.toLowerCase() === 'Home') {
          parent.postMessage({ command: 'on-confirm-out-app' }, '*')
        } else {
          this.$router.go(-1)
        }
      }
      if (resp.command === 'device-info') {
        const data = resp.data
        setSettingDevice(data)
        let versionApp = compareVersions(data.appVersion, version)
        this.$store.state.versionApp = versionApp

        const allowedWithoutDeviceInfo = process.env.VUE_APP_ALLOWED_WORKING_WITHOUT_DEVICE_INFO === 'true';
        if (allowedWithoutDeviceInfo || (data && (data.mac || data.serial || data.uniqueId))) {
          this.shouldRenderApp = true;
        } else {
          this.shouldRenderApp = false;
          this.accessDeniedVisible = true;
        }
      }
    },
    HandlShowBetslip(){
      EventBus.$emit('eventBetslip');
    },
    async logoutUser() {
      try {
        const token = getAccessToken();
        if(token){
          AuthService.logout();
          this.$store.dispatch("clearAllBetslip");
          this.$store.dispatch("clearAllCheckout");
          await this.$router.push("/login");
          const param = {
            title: "Your session has timed out due to inactivity. Please log in again to continue.",
            status: "error",
          };
          EventBus.$emit("on-show-notications", param);
        }
      } catch (error) {
        console.log(error);
      }
    },
    handleResetTime(){
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(this.logoutUser, TIME_LOGOUT * 60 * 1000);
    },

    handleVisibilityChange() {
        if (document.visibilityState === 'hidden') {
            localStorage.setItem('lastTime', new Date().toISOString());
        } else if (document.visibilityState === 'visible') {
            this.checkTimeOnReturn();
        }
    },

    checkTimeOnReturn() {
      const token = getAccessToken();
      const lastTime = localStorage.getItem('lastTime');
      if (lastTime) {
          const currentTime = new Date();
          const timeDiff = currentTime - new Date(lastTime);

          const minutesDiff = timeDiff / 1000 / 60;
          if (minutesDiff > TIME_LOGOUT) {
              if (token) {
                  this.logoutUser();
              }
          }
          localStorage.removeItem('lastTime');
      }
  },

  },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/main.scss";
</style>
